import React, { SVGProps } from 'react'

const CopyDone: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      aria-hidden
      focusable="false"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9.18901 0.967469C9.40116 0.725014 9.37659 0.356486 9.13414 0.144338C8.89168 -0.0678096 8.52315 -0.0432411 8.311 0.199214L3.13542 6.11416L1.02234 3.69921C0.810197 3.45676 0.441668 3.43219 0.199214 3.64434C-0.0432411 3.85649 -0.0678096 4.22501 0.144338 4.46747L2.69642 7.38413C2.80719 7.51073 2.96721 7.58334 3.13542 7.58334C3.30364 7.58334 3.46366 7.51073 3.57443 7.38413L9.18901 0.967469Z"
        fill="var(--Labels-Functional-Secondary, #FB2576)"
      />
      <path
        d="M11.5223 0.967469C11.7345 0.725014 11.7099 0.356486 11.4675 0.144338C11.225 -0.0678096 10.8565 -0.0432411 10.6443 0.199214L5.41502 6.17557C5.20069 6.0799 4.94047 6.12 4.76461 6.29586C4.5368 6.52367 4.5368 6.89301 4.76461 7.12082L5.05627 7.41249C5.17043 7.52665 5.3268 7.58839 5.48816 7.58302C5.64952 7.57764 5.80144 7.50564 5.90776 7.38413L11.5223 0.967469Z"
        fill="var(--Labels-Functional-Secondary, #FB2576)"
      />
      <path
        d="M2.7589 3.10104C2.53856 2.86601 2.1694 2.8541 1.93437 3.07444C1.69934 3.29479 1.68743 3.66394 1.90777 3.89897L3.00152 5.06564C3.22186 5.30067 3.59102 5.31258 3.82605 5.09224C4.06108 4.87189 4.07299 4.50274 3.85265 4.26771L2.7589 3.10104Z"
        fill="var(--Labels-Functional-Secondary, #FB2576)"
      />
    </svg>
  )
}

export default CopyDone
